import { Component , ViewChild} from '@angular/core';
import {Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';

import { HomePage } from '../pages/home/home';
import { PositionPage } from '../pages/position/position';
import { IncomeSheetPage } from '../pages/income-sheet/income-sheet';
import { DailyPage } from '../pages/daily/daily';
import { LoginPage } from '../pages/login/login';
import { MyPosProvider } from '../providers/my-pos/my-pos';
import { DailySumPage } from '../pages/daily-sum/daily-sum';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
 public rootPage:any = HomePage;
 public UName:string = "a";
 
  pages: Array<{title: string, component: any}>;
  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    public storage: Storage,public PosProvider:MyPosProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      

      this.storage.get('MyURL')
      .then(data => {
        if( data)
    { 
      this.PosProvider.MyDomain=data;

    }
    
      });

      this.storage.get('name')
    .then(data => {
    if( data)
    {     
      this.PosProvider.UName=data;

      this.UName = this.PosProvider.UName;
      this.rootPage = HomePage;      
    }
    else
    {
      this.rootPage = LoginPage;
    }
  });


  


    });
    

    this.pages = [
      //{ title: this.UName, component: HomePage },
      { title: 'الشاشة الرئيسية', component: HomePage },
      { title: 'المركز المالي', component: PositionPage },
      { title: 'قائمة الدخل', component: IncomeSheetPage },
      { title: 'تقرير الحركة تفصيلي', component: DailyPage },      
      { title: 'تقرير الحركة اجمالي', component:DailySumPage},
      { title: 'تسجيل خروج', component: LoginPage }
    ];
  }

 public openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
   if( page.title == 'تسجيل خروج')
   {
    this.ClearLogOut('name');
   }
  }
  ClearLogOut(word){
    //this.storage.clear();
    
        this.storage.ready().then(
        () => {
          this.storage.remove(word);
        });
      
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts